module.exports = __webpack_public_path__ + "img/CheckSuccess.eae37dcc.svg";